var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedCross = function SvgRedCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AF1D21",
    d: "M18.496 16.129c.736.68.736 1.869 0 2.549-.34.34-.793.51-1.246.51-.51 0-.963-.17-1.303-.51L10 12.73l-6.004 5.948c-.34.34-.793.51-1.246.51-.51 0-.963-.17-1.303-.51a1.747 1.747 0 0 1 0-2.55l5.948-6.003-5.948-5.947a1.747 1.747 0 0 1 0-2.55 1.747 1.747 0 0 1 2.55 0L10 7.577l5.947-5.947a1.747 1.747 0 0 1 2.55 0c.735.68.735 1.869 0 2.549l-5.948 6.004z"
  })));
};
export default SvgRedCross;